import { useCallback, useState } from 'react';

import { useErrorDescriptions } from 'constants/errorDescriptions';
import { BannerData, PalletReport } from 'interfaces';
import { logNetworkError } from 'utils/logNetworkError';

export const useDamagedLostPalletsPage = () => {
   const [palletReports, setPalletReports] = useState<PalletReport[]>([]);
   const [isLoading, setIsLoading] = useState(false);
   const [bannerData, setBannerData] = useState<BannerData | null>(null);

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const handleError = useCallback(
      (error: unknown) => {
         setBannerData({ variant: 'error', description: DEFAULT_ERROR_DESCRIPTIONS.FETCH_DATA });
         logNetworkError(error);
      },
      [DEFAULT_ERROR_DESCRIPTIONS.FETCH_DATA],
   );

   return {
      palletReports,
      isLoading,
      bannerData,
      handleError,
      setPalletReports,
      setIsLoading,
      setBannerData,
   };
};
